import { Button, Grid2, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ConfirmDeleteModal, GKDataGrid } from "components";
import DashboardLayout from "layouts/DashboardLayout";
import { useState } from "react";
import toast from "react-hot-toast";
import { MdDelete } from "react-icons/md";
import { TbArrowBackUp } from "react-icons/tb";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";
import BrokerMasterDetailsModal from "./BrokerMasterDetailsModal";

function BrokerMasterDetailsPage() {
  const navigate = useNavigate();

  const { id } = useParams();

  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [detailsData, setDetailsData] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [brokerTempleId, setBrokerTempleId] = useState<any>(0);

  const { data, isLoading, refetch } = useQuery({
    queryKey: [QueryKeys.BROKER_MASTER_DETAILS_LIST],
    queryFn: () => axiosInstance.get(`/broker-integration/?broker_id=${id}`),
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const { mutate: handleDeleteBrokerDetails } = useMutation({
    mutationKey: ["DELETE_BROKEN"],
    mutationFn: () =>
      axiosInstance.delete(`/broker-integration/${brokerTempleId}/delete/`),
    onSuccess: (response) => {
      refetch();
      toast.success(
        response?.data?.message || "Delete Broker Details Successfully"
      );
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("File Type", "fileType", 100, 1),
    },
    {
      ...extraColumnsField("Daily Bulk", "dailyBulk", 100, 1),
    },
    {
      ...extraColumnsField("Version", "version", 50, 1),
    },
    {
      ...extraColumnsField("Template", "template", 250, 1),
      renderCell: (item) => (
        <Button
          href={item?.row?.template}
          target="_blank"
          onClick={(event) => {
            event?.stopPropagation();
          }}
        >
          View File
        </Button>
      ),
    },
    {
      ...extraColumnsField("Actions", "action", 80, 1),
      headerAlign: "right",
      align: "right",
      type: "action",
      renderCell: (item) => (
        <Grid2 container gap={1} justifyContent={"flex-end"}>
          <IconButton
            className="mr-2"
            color="primary"
            onClick={(event) => {
              event.stopPropagation();
              setBrokerTempleId(item.id);
              setConfirmationModal(true);
            }}
          >
            <MdDelete size={20} />
          </IconButton>
        </Grid2>
      ),
    },
  ];

  return (
    <DashboardLayout
      title="Broker Master Details"
      toolbar={
        <Button size="extraSmall" onClick={() => navigate(-1)}>
          Back &nbsp; <TbArrowBackUp />
        </Button>
      }
    >
      <Grid2 container spacing={2}>
        <Grid2 size={12} display={"flex"} justifyContent={"flex-end"}>
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              setDetailsData({});
              setOpenDetailsModal(true);
            }}
          >
            Create Broker Master
          </Button>
        </Grid2>
        <Grid2 size={12}>
          <GKDataGrid
            loading={isLoading}
            columns={columns}
            rows={data?.data?.data || []}
            onRowClick={(row) => {
              setDetailsData(row.row);
              setOpenDetailsModal(true);
            }}
          />
        </Grid2>
      </Grid2>

      {openDetailsModal && (
        <BrokerMasterDetailsModal
          isModalOpen={openDetailsModal}
          setIsModalOpen={setOpenDetailsModal}
          refetch={refetch}
          detailsData={detailsData}
        />
      )}

      {confirmationModal && (
        <ConfirmDeleteModal
          open={confirmationModal}
          setOpen={setConfirmationModal}
          onDelete={() => handleDeleteBrokerDetails()}
          title={"Broker Master"}
          isDelete
        />
      )}
    </DashboardLayout>
  );
}

export default BrokerMasterDetailsPage;
